/* eslint-disable max-len */

export default {
  lang: "Spanish",
  homeScreen: {
    title: "BIENVENIDO A",
    titleSub: "NEVADA",
    titleSub1: "El Oeste más Extraño y Salvaje",
    stayConnected: "Mantente Conectado",
    comingSoon: "Próximamente",
    messages: "Mensajes",
    unlock: 'Desbloquea este artículo completando la sección Aprender.',
  },
  loginScreen: {
    version2: {
      homeTitle: "Vamos a ver si podemos encontrar un perfil existente para usted en nuestro sistema.",
      homeTitleSub: "Introduzca la dirección de correo electrónico que utiliza habitualmente para acceder a los programas de formaci",
      noAccount: "No se ha encontrado ninguna cuenta ({email}), inténtalo con otra dirección de correo electrónico o crea una cuenta ahora.",
      continueButton: "Continuar",
      success: "Ha actualizado correctamente su cuenta. En breve será redirigido a la página de inicio.",
      successNewAccount: "Para completar su inscripción, recibirá un correo electrónico de confirmación para verificar su cuenta.",
      loginButton: "Inicio de sesión",
      matchFound: "Hemos encontrado una coincidencia, por favor, introduzca su contraseña para continuar.",
      magicLink: "Inicie sesión a través de un enlace en su correo electrónico:",
      magicLinkButton: "Solicitar Magic Link",
      magicLinkTitle: "Recibe un enlace directo en tu correo electrónico que te permitirá registrarte al instante.",
      otherEmailButton: "Enviar",
      title: "Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.",
      titleIndustry: "Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.",
      register: "Crear una cuenta",
      agent: "Asesor de viajes",
      visitor: "Visitante del sector",
      step1: "Paso 1: Tipo de usuario",
      step2: "Paso 2: Crear una cuenta",
      step3: "Paso 3: Cree su perfil",
      marketingOptIn: "¿Está seguro de que no le interesa seguir vinculado al equipo de comercio de viajes de este programa?",
      optIn: "Sí, me interesa",
      optOut: "No me interesa",
      step2Sub1: "Háblenos de usted",
      step2Sub2: "Háblenos de su empresa",
      privacyHead: "PREFERENCIAS DE COMUNICACIÓN",
      privacySub: "Marque las casillas que aparecen a continuación para asegurarse de que recibe comunicaciones importantes del equipo comercial de viajes del proveedor (actualizaciones y anuncios de productos, recompensas, incentivos, FAMs, etc.) e iniciativas de redes comerciales de viajes y apoyo a las ventas de TravPRO Mobile.",
      privacy: "Protegemos su privacidad y nunca vendemos, abusamos o traicionamos su confianza.",
      store: "Descarga fácilmente este programa en tu tienda de aplicaciones:",
      powered: "PODER DE",
      toastMessage: {
        forgotSuccess: "Le hemos enviado por correo electrónico un enlace para restablecer su contraseña. Serás redirigido a la página de inicio de sesión en 10 segundos.",
        emailNotExisting: "La dirección de correo electrónico que has introducido no existe.",
        magicLinkMessage: "Por favor, espera, te estamos registrando ahora mismo.",
        magicLinkError: "No hemos podido encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Será redirigido en 10 segundos.",
        magicLinkError1: "No hemos podido encontrar un token válido, por favor inicie sesión o solicite un nuevo enlace mágico. Si este problema persiste, póngase en contacto con nosotros en: info@travpromobile.com.",
        magicLinkError2: "No hemos podido encontrar su cuenta en nuestra base de datos, por favor inicie sesión manualmente. Será redirigido en 10 segundos.",
        magicLinkSuccess: "Comprueba tu correo electrónico en {email}. Tiene un enlace mágico que te registrará.",
        magicLinkErrorWait: "Por favor, espera 5 minutos entre peticiones de enlace mágico.",
        emailNotFoundError: "La dirección de correo electrónico que ha introducido no se encuentra en nuestros registros. Por favor, compruebe si hay errores ortográficos o cree una cuenta."
      },
      errors: {
        zipCodeNotFound: "Código postal no encontrado, inténtelo de nuevo",
        zipCodeOnlyNumbers: "El código postal sólo puede contener números",
        password: "Introduzca una contraseña",
        passwordNotMatching: "Las contraseñas introducidas no coinciden",
        passwordTooShort: "La contraseña debe tener al menos 8 caracteres",
        emailExists: "Esta dirección de correo electrónico ya existe o no es válida. Inténtelo con otra dirección de correo electrónico o acceda a su cuenta.",
        fillInAllFields: "Rellene todos los campos obligatorios",
        fillInEmail: "Por favor, introduzca su dirección de correo electrónico.",
        emailNotExisting: "La dirección de correo electrónico que ha introducido no existe."
      },
      fields: {
        forgotSubCopy: "¿Has olvidado tu contraseña y quieres cambiarla? ",
        forgotSubCopy2: "¿Quiere saltarse la contraseña por completo? Le enviaremos un correo electrónico con un enlace mágico que le permitirá acceder automáticamente al programa. ",
        city: "Ciudad",
        companyName: "Nombre de la empresa",
        role: "Su función",
        description: "¿Cuál describe mejor la actividad de su empresa?",
        country: "País",
        password: "Contraseña",
        passwordRegister: "Elija una contraseña (mínimo 8 caracteres)",
        passwordConfirm: "Confirmar contraseña",
        firstName: "Nombre",
        lastName: "Apellido (Familia)",
        agency: "Nombre de su agencia",
        title: "Su función (seleccione una)",
        company: "Nombre de la empresa",
        select: "Seleccione una opción",
        state: "Estado",
        province: "Provincia/Región/Estado",
        zipCode: "Código postal",
        postalCode: "Código postal",
        affiliate: "¿A qué grupo está afiliada su agencia PRINCIPAL?",
        hostAgency: "¿Su agencia de acogida?",
        executive: "Ejecutivo",
        management: "Gestión",
        marketing: "Marketing",
        sales: "Ventas",
        coordinator: "Coordinador",
        opt: "Manténgase en contacto con el equipo de comercio de viajes de este programa y reciba actualizaciones.",
        optMarketing: "Manténgase en contacto con TravPRO en relación con programas y eventos similares.",
        retail: "Fachada de tienda",
        home: "Agente a domicilio",
        independent: "Contratista independiente",
        host: "Organismo anfitrión",
        call: "Centro de llamadas o agencia web",
        other: "Otros",
        describes: "¿Qué es lo que mejor describe su actividad y la de su agencia?"
      }
    },
    title: "Programa de Capacitación Profesional de Viajes y Habilitación de Ventas",
    welcome: {
      headerTop: "Bienvenido a",
      headerBottom: "Travel Nevada "
    },
    sellingPoints: {
      0: "Aprende, promueve y vende sobre la marcha",
      1: "Capacitación multimedia a través de dispositivos",
      2: "Certificado de Finalización",
      3: "Presentaciones de Ventas listas para usarse",
      4: "Materiales Promocionales de Alto Impacto",
      5: "Consejos y Promociones de Expertos",
      6: "Directorio de Productos en tiempo real",
      7: "Noticias y actualizaciones Oportunas"
    },
    emailPrompt: "Ingresa tu dirección de correo electrónico y contraseña para confirmar que eres un profesional de viajes.",
    tAndC: {
      agree: "Al continuar, aceptas nuestros ",
      privacyPolicy: "política de privacidad",
      and: " y ",
      termsConditions: "Términos y Condiciones"
    },
    fields: {
      agency: "Agencia",
      email: "Correo electrónico",
      password: "Contraseña*",
      passwordConfirm: "Confirma tu contraseña *",
      firstName: "Nombre  *",
      lastName: "Apellido *",
      city: "Ciudad *",
      agencyName: "Nombre de la Agencia *",
      stateProvince: "Provincia / Estado *",
      required: "Requerido",
      invalidEmail: "Dirección de correo electrónico no válida",
      opt: "¡Mantente en contacto! Sí, me gustaría suscribirme a las comunicaciones de Travel Nevada que me mantendrán informado sobre noticias, eventos, incentivos, FAM y más.",
      complete: "Paso 2: Completa tu perfil",
      tell: "Cuéntanos acerca de tí",
      title: "Puesto *",
      host: "Nombre de la agencia anfitriona",
      country: "País / Región",
      select: "Por favor, selecciona una opción a continuación",
      header2: "¿Qué segmento(s) vendes principalmente?",
      step2: "Describe tu negocio",
      leisure: "Ocio",
      corporate: "Corporativo",
      group: "Grupo",
      affiliate: "¿Cuál es tu Principal Afiliación?",
      forgot: '¿Ha olvidado su contraseña? Haz clic en el botón de abajo y te enviaremos un correo electrónico para restablecer tu contraseña.',
    },
    noAgent: {
      noAgentButton: 'No soy asesor',
      title: "Gracias por tu interés en Travel Nevada.",
      messageWeb: "El contenido de este sitio es exclusivamente para profesionales de viajes. Para obtener más información sobre Nevada, visita:",
      messageMobile: "Parte del contenido de esta aplicación es exclusivo para profesionales de viajes, pero siéntete libre de buscar ver la vista previa de lo que esta aplicación tiene para ofrecer presionando 'Continuar'.",
      continue: "Continuar",
      visitWebsite: "Visita la página web"
    },
    newUser: "Nuevo Usuario",
    register: "Registro",
    registered: "Este correo electrónico ya está registrado",
    forgot: 'Restablecer contraseña',
    header: "Tómate un momento para completar toda la información a continuación, ya que esto es lo que llenará tu perfil e información de contacto.",
    step1: "Paso 1: Completa tu dirección de correo electrónico y elije una contraseña."
  },
  welcomeScreen: {
    title: "Bienvenido a Travel Nevada",
    helloUser: "Hola {{name}}",
    hello: "Hola,",
    fromAgency: "de {{agency}}",
    notUser: "No {{name}}?",
    introOnline: "¡Capacítate en el momento en línea o precarga el contenido para que siempre esté disponible para su uso sin conexión!",
    introOffline: "Ya tienes la última versión precargada. ¡Comienza a capacitarte o a vender en cualquier momento y en cualquier lugar!",
    startTraining: "Comienza a aprender",
    continueTraining: "Continua aprendiendo",
    graduated: "¡Felicidades!",
    downloader: {
      preload: "Precarga",
      stop: "Deténte",
      init: "Iniciando...",
      lastUpdate: "Última actualización:"
    }
  },
  trainingScreens: {
    start: "Comienza",
    continue: "Continua",
    review: "Revisa",
    restart: "Reinicia",
    durationInMinutes: "{number} minutos",
    percentageComplete: "{number}%  Completado",
    unlock: "Desbloquea este capítulo completando el capítulo de entrenamiento {number}.",
    unlockSubtitle: "Desbloquea más capítulos completando los capítulos de entrenamiento.",
    allUnlocked: "¡Has desbloqueado todos los capítulos!",
    certificate: "Certificado",
    courseComplete: "Continua",
    endReached: "Has llegado al final",
    retainEnd: "Utiliza la barra superior para navegar por este capítulo o pulsa el botón Atrás para volver a la vista general.",
    watchListenRead: "Ve, escucha y lee más",
    trouble: "Parece que tienes problemas, vuelve a leer el contenido de las páginas anteriores y vuelve a intentarlo.",
    confirm: "Confirma tu respuesta",
    choose: "Por favor elige una respuesta",
    skip: "Regresa",
    viewAllTitle: "Consejo para tu Capacitación",
    viewAll: "Para pasar a la página siguiente, haz clic en los iconos para ver el contenido complementario. Se han proporcionado videos, mapas y otra información útil para mejorar tu capacitación y garantizar que alcances el nivel PRO.",
    fillBlanks: "Llena el(los) espacio(s) en blanco:",
    next: "Siguiente pregunta",
    retry: "Intenta de nuevo",
    fastTrackText: {
      success: "¡Enhorabuena, has aprobado el curso Fast Track y haz desbloqueado el resto de la capacitación!",
      failed: "Lamentablemente, no aprobaste el curso Fast Track, ¡puedes reanudar la capacitación para obtener tu diploma!"
    },
    fastTrack: "¡Conviértete en una Superestrella de Viajes Suiza!",
    fastTrackExplanation: "¡Simplemente responde el cuestionario en las siguientes páginas para tener la oportunidad de ganar un FAM a Suiza!<br><br><span style=\"font-weight: bold\">Encontrarás todas las respuestas a las preguntas del cuestionario de la siguiente manera: </span><br><br>1. El contenido aprendido en los módulos Rail Europe y Suiza<br><br>2. Y en los siguientes sitios web:<br><a href=\"https://www.myswitzerland.com\" target=\"_blank\">www.myswitzerland.com</a><br><a href=\"https:/ /www.bucherer.com\" target=\"_blank\">www.bucherer.com</a><br><a href=\"https://www.mysts.net\" target=\"_blank\">www.mysts. red</a><br><br><span style=\"font-weight: bold\"> ¡Asegúrate de revisar estos recursos en detalle antes de realizar el cuestionario! Solo aquellos con la puntuación más alta tendrán la oportunidad de ser invitados a la FAM.</span>",
    fastTrackButton: "Haz clic aquí para tomar la Prueba de la Superestrella Suiza",
    grading: "Tu calificación final es: {grade}%"
  },
  nav: {
    home: "Inicio ",
    train: "Aprender",
    learn: "Aprender",
    retain: "Retener",
    directory: "Directorio",
    showRoom: "Escaparates",
    showcases: "Escaparates",
    offers: "Ofertas",
    promote: "Promover",
    sell: "Vender",
    info: "Información",
    rewards: "Recompensas",
    media: "Medios de comunicación",
    favorites: "Favoritos",
    contact: "Contacto",
    reportCard: "Ver Diploma",
    accountSettings: "Configuraciones de la cuenta",
    messages: "Mensajes",
    search: "Buscar"
  },
  contentHeaders: {
    train: "Aprender",
    retain: "Retener",
    subappsMain: "Módulos de Especialización",
    subapps: "Módulos de MicroLearning para Socios",
    maintrainings: "La Base ",
    subtrainings: "La Experiencia",
    subtrainingsFull: 'Compañeros de Ventas para Socios',
  },
  pageDescriptions: {
    train: "Educa, participa y conviértete en el experto.",
    showroom: "Escaparates",
    retain: "¡Felicitaciones por completar tu capacitación! Ahora has desbloqueado el recurso de acceso para retener tu conocimiento de experto y habilitar esfuerzos de ventas. Utiliza esta área para responder de preguntas sobre un producto como experto o para hacer una presentación de ventas improvisada, en cualquier momento, en cualquier lugar y desde cualquier dispositivo.",
    promote: "Comparte estos elementos para despertar el interés y comenzar una conversación con clientes actuales y potenciales.",
    sell: "Responde las preguntas de los clientes y cierra la venta como un profesional con extensos recursos  y soporte de ventas especializado.",
    favorites: "Echa un vistazo a tu contenido personal favorito ",
    search: "Revisa todo el contenido",
    subapps: "Obtén más información de nuestros socios",
    maintrainings: 'Todo el terreno que necesitas cubrir para empezar a vender Nevada como un profesional.',
    subtrainings: 'Obtén una Insignia de Especialista completando estos rápidos módulos para socios de un solo capítulo.',
    subtrainingsFull: 'Acelera aún más tu experiencia en Nevada y tu poder de ventas completando estos compañeros de entrenamiento y ventas de varios capítulos para obtener un certificado.',
  },
  general: {
    showcase: "Escaparate",
    next: "Siguiente ",
    yes: "Sí",
    no: "No",
    previous: "Anterior",
    submit: "Enviar",
    back: "Atrás",
    close: "Cerrar ",
    page: "Página",
    search: "Búsqueda",
    logIn: "Iniciar sesión",
    logOut: "Cerrar sesión",
    viewItem: "Ver {type}",
    imageNotFound: "Imagen no encontrada",
    noResultsFor: "No se han encontrado resultados para: {{query}}",
    noFavorites: "Aún no tienes favoritos.",
    noMessages: "¡Aún no has recibido ningún mensaje!",
    resultsFor: "Resultados para: {{query}}",
    showAll: "Mostrar todo",
    connectionError: "Error de conexión",
    alreadyExists: "Ya existe",
    pageNotFound: "¡404 Pagina no encontrada!",
    oops: "UH oh...",
    overview: "Volver a la vista general",
    complete: "Continuar",
    courseComplete: "¡Capítulo Completo!",
    chapterComplete: "¡Capítulo Terminado!",
    message: "{count} Mensaje",
    messagePlural: "{count} Mensajes",
    viewBadge: 'Ver',
    viewBadge2: 'Insignia'
  },
  itemTypes: {
    image: "Imagen",
    brochure: "Recopilación",
    layout: "Diseño",
    web: "Sitio web",
    pdf: "PDF",
    carousel: "Recopilación"
  },
  questions: {
    dials: "Gira los diales para que coincidan con la respuesta.",
    fitb: "Llena el (los) espacio(s) en blanco",
    flip: "Cambia el número para que coincida con la respuesta",
    multipleChoice: "Elige la(s) respuesta(s) correcta(s)",
    slider: "Elije la respuesta correcta usando el control deslizante",
    map: "Responde la pregunta tocando la ubicación correcta en el mapa",
    dropdown: "Elegir...",
    true: "Verdadero",
    false: "Falso"
  },
  reportCard: {
    download: "Descargar",
    email: "Correo electrónico",
    print: "Imprimir"
  },
  cookies: {
    consent: "ACEPTAR",
    optout: "Optar por no",
    settings: "Configuración de privacidad",
    message: "¡No nos has dicho nada sobre tus preferencias de privacidad de datos! Está bien, pero nos gustaría ofrecerte la mejor experiencia con el Asistente de ventas.",
    disabled: "Parece que has desactivado el uso de cookies.",
    use: "{{appName}} requiere el uso de cookies para brindar la mejor experiencia.",
    details: "¿Para qué se utilizan las cookies?",
    enable: "Ve aquí cómo habilitar las cookies {{here}}.",
    here: "aquí"
  },
  notLoggedIn: {
    super: "No has iniciado sesión",
    title: "Necesitas ingresar a la página para ver este contenido",
    guest: "Invitado"
  },
  demo: {
    message: "Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto terminado.",
    consent: "¡Entendido!"
  },
  share: {
    header: "¡Comparte este recurso en tus redes sociales favoritas!",
    download: "Descargar"
  },
  sharing: {
    copyURL: "Copiar Link",
    copied: "Copiado"
  },
  breadCrumbs: {
    page: "Página"
  },
  onMobile: {
    header: "Parece que estás intentando acceder a la aplicación {appName} desde un dispositivo móvil",
    body: "Para descargar este programa, simplemente visita la tienda de aplicaciones y busca {appName} o haz clic en uno de los botones a continuación",
    benefits: {
      1: "Aprende, promueve y vende sobre la marcha",
      2: "Capacitación multimedia a través de dispositivos",
      3: "Certificado de Finalización",
      4: "Presentaciones de Ventas listas para usarse",
      5: "Materiales Promocionales de Alto Impacto",
      6: "Directorio de Productos en Tiempo Real",
      7: "Noticias y actualizaciones oportunas",
      header: "Esto te proporcionará:"
    }
  },
  directory: {
    attractions: "Atracciones",
    accommodations: "Alojamientos",
    dining: "Comida",
    nightlife: "Vida nocturna",
    artsculturehistory: "Arte, Cultura e Historia",
    themeparks: "Parques Tematicos",
    foodbeverage: "Alimentos y Bebidas",
    sportsrecreationoutdoors: "Actividades al Aire Libre/Deportes y Recreación",
    otheraccommodations: "Otros alojamientos",
    shopping: "Compras",
    weddingservices: "Servicios para Bodas",
    medicalservices: "Servicios Médicos",
    golf: "Golf",
    transportationservices: "Servicios de transporte",
    history: 'Historia/Patrimonio',
    spas: "Spas",
    filters: "Filtros",
    reset: "Restablecer filtros",
    other: "Otro",
    view: "Ver ahora",
    amount: "Cantidad de resultados",
    museums: "Museos"
  },
  custom: {
    splitUsers: "Soy un",
    brandAmbassador: "Embajador de la marca",
    travelPro: "Agente de viajes profesional"
  },
   search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
};